import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import tabReducer from "./tabReducer";
import candidateListReducer from "./candidateReducer";
import jobListingReducer from "./jobReducer";
import mpLaunchesReducer from "./mpLaunchesReducer";

const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  tab: tabReducer,
  candidates: candidateListReducer,
  jobs: jobListingReducer,
  mpLaunch:mpLaunchesReducer
});

export default rootReducers;
